module.exports = __webpack_public_path__ + "img/ban.264d3396.svg";